import { Link } from 'react-router-dom';
import i18n from 'i18next';
import { isMobileOnly } from 'react-device-detect';
import { Typography } from 'antd';
import { BaseType } from 'antd/es/typography/Base';
import cn from 'classnames';

import { ISecondaryMarketItem } from 'models';

import { CountryFlag, Popover } from 'componets/ui';
import { InvestmentSecondaryMarket } from 'pages/Account/MyInvestments/InvestmentSecondaryMarket';
import { SecondaryMarketCounteroffer } from './SecondaryMarketCounteroffer';

import Utils from 'utils/utils';
import { RequestStatus } from 'utils/constants';

import s from './index.module.scss';
import { loanStatusColumn } from '../../../MyInvestments/columnsTable';

const { t } = i18n;

export const columns = [
	{
		title: `ID/${t('projectText')}`,
		dataIndex: 'loanId',
		width: 200,
		render: (loanId: number, row: ISecondaryMarketItem) => {

			return (
				<div>
					<div className={s.row}>
						<Popover content={row.country.title} trigger="hover">
							<div className={s.flag}>
								<CountryFlag country={row.country.iso} />
							</div>
						</Popover>
						<Link to={`/account/projects/${row.loanId}`} className={cn(s.link, s.id)}>
							{row.loanId}
						</Link>
					</div>
					<div>
						<Link to={`/account/projects/${loanId}`} className={s.link}>
							{row.projectTitle}
						</Link>
					</div>
				</div>
			);
		},
	},
	loanStatusColumn,
	{
		title: t('projectTypeText'),
		dataIndex: 'loanTermType',
		render: (loanTermType: string) => {
			return <Typography.Text>{Utils.formatProjectType(loanTermType)}</Typography.Text>;
		},
		width: 160,
		textWrap: 'word-break',
	},
	{
		title: t('interestRateText'),
		dataIndex: 'investmentInterest',
		render: (interest: number) => {
			return `${interest}%`;
		},
		sorter: true,
		width: 115,
		textWrap: 'word-break',
	},
	{
		title: t('dateOfInvestmentText'),
		dataIndex: 'investmentDate',
		width: 125,
		textWrap: 'word-break',
	},
	{
		title: t('finalEstimatedPaymentDateText'),
		dataIndex: 'finalPaymentDate',
		sorter: true,
		width: 125,
		textWrap: 'word-break',
	},
	{
		title: t('initialInvestmentAmountText'),
		dataIndex: 'remainingPrincipal',
		render: (remainingPrincipal: number) => {
			return <Typography.Text>{Utils.moneyFormat(remainingPrincipal)}</Typography.Text>;
		},
		width: 120,
		sorter: true,
		textWrap: 'word-break',
	},
	{
		title: t('sellingPriceText'),
		dataIndex: 'saleAmount',
		render: (saleAmount: number, row: ISecondaryMarketItem) => {
			const percent = (saleAmount * 100) / +row.remainingPrincipal - 100;
			let type: BaseType = 'secondary';

			if (percent < 0) {
				type = 'success';
			}

			if (percent > 0) {
				type = 'danger';
			}
			return (
				<div className={s.columnText}>
					<Typography.Text>{Utils.moneyFormat(saleAmount)}</Typography.Text>
					<Typography.Text type={type} className={s.percent}>
						{percent > 0 && '+'}
						{percent === 0 ? percent : percent.toFixed(2)}%
					</Typography.Text>
				</div>
			);
		},
		width: 120,
		sorter: true,
		textWrap: 'word-break',
	},
	{
		title: t('availableUntilText'),
		key: 'offerAvailableUntil',
		dataIndex: 'saleValidUntil',
		sorter: true,
		width: 125,
		textWrap: 'word-break',
	},
	{
		title: '',
		dataIndex: 'seller',
		render: (seller: boolean, row: ISecondaryMarketItem) => {
			const isBuy = row.saleStatus === 'ACTIVE';
			const isCancel = seller;

			return (
				<div className={s.icons}>
					{isBuy && !isCancel && (
						<SecondaryMarketCounteroffer
							id={row.id}
							pendingCounterOffer={row.pendingCounterOffer}
						/>
					)}
					<InvestmentSecondaryMarket
						isSell={false}
						isCancelSell={isCancel}
						isPending={row.saleStatus === RequestStatus.PENDING.toUpperCase()}
						isBuy={isBuy}
						activeSaleId={row.id}
						projectId={row.loanId}
						isSecondaryMarket
						row={row}
					/>
				</div>
			);
		},
		width: 130,
		fixed: isMobileOnly ? '' : 'right',
	},
];
